export default "__VITE_PUBLIC_ASSET__97e2364f__"